import { fetchAddressSuggestion } from 'fetch/fetchAddress';
import { useRef, useState } from 'react';
import { GeonorgeAddress } from 'types/Geonorge/GeonorgeAddress';

export const useFetchAddress = () => {
  const [addresses, setAddresses] = useState<Array<GeonorgeAddress>>([]);

  const searchKeyword = useRef('');
  const searchTimeout = useRef<ReturnType<typeof setTimeout>>();

  const searchingAddress = () => {
    searchTimeout.current = setTimeout(async () => {
      searchTimeout.current = null;

      /* Search the keyword after user has been finished typing in one second */
      const suggestionResponse: Array<GeonorgeAddress> =
        await fetchAddressSuggestion(searchKeyword.current);

      setAddresses(suggestionResponse);
    }, 1000);
  };

  const search = (newKeyword: string) => {
    searchKeyword.current = newKeyword.toLowerCase();

    if (newKeyword && newKeyword.length > 0) {
      !searchTimeout.current && searchingAddress();
    } else {
      setAddresses([]);
    }
  };

  return {
    suggestion: addresses,
    search,
  };
};
